import { useEffect, useState } from "react";
import { usePageState } from "../Layout";
import { clientOnlineMenuUrl } from "../functions/requests";
import IconClose from "../icons/IconClose";
import IconEdit from "../icons/IconEdit";
import IconEyeOpen from "../icons/IconEyeOpen";
import IconLoadingWave from "../icons/IconLoadingWave";
import Button from "./Button";
import Message from "./Message";
import IconPlus from "../icons/IconPlus";
import Spacer from "./Spacer";
import IconFolder from "../icons/IconFolder";
import IconFile from "../icons/IconFile";
import IconReload from "../icons/IconReload";

export default function List({
  showActionsHeader = true,
  headers = [],
  items = [],
  itemType = "user",
  isLoading = true,
  disableOnView = false,
  onView = null,
  disableOnEdit = false,
  onEdit = null,
  disableOnDelete = false,
  onDelete = null,
  disableOnAccept = false,
  onAccept = null,
  disableOnReject = false,
  onReject = null,
  disableOnReset = false,
  onReset = null,
  disableOnShowCustomerSubscriptions = false,
  onShowCustomerSubscriptions = null,
  disableOnAddNewCustomerSubscription = false,
  onAddNewCustomerSubscription = null,
}) {
  const { pageState, setPageState } = usePageState();
  const [userData, setUserData] = useState(pageState.userData || null); // Get connected user data

  return isLoading !== true ? (
    items.length > 0 ? (
      <>
        <div className={`list`}>
          <table>
            <thead>
              <tr>
                {showActionsHeader && <th>Actions</th>}
                {headers.length > 0 &&
                  headers.map((header, index) => {
                    return <th key={index}>{header}</th>;
                  })}
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => {
                return (
                  <tr key={index}>
                    {showActionsHeader && (
                      <td className="actions">
                        <div className="actions">
                          {onView !== null && !disableOnView && (
                            <Button
                              icon={<IconEyeOpen color="white" />}
                              type="info"
                              onClicked={() => onView(item)}
                            />
                          )}
                          {onEdit !== null && !disableOnEdit && (
                            <>
                              {itemType === "knowledge-base-record" &&
                              item.owner.uuid !== userData.uuid ? (
                                <></>
                              ) : (
                                <Button
                                  icon={<IconEdit />}
                                  type="info"
                                  onClicked={() => onEdit(item)}
                                />
                              )}
                            </>
                          )}
                          {onReset !== null && !disableOnReset && (
                            <>
                              {itemType === "knowledge-base-record" &&
                              item.owner.uuid !== userData.uuid ? (
                                <></>
                              ) : (
                                <Button
                                  icon={<IconReload />}
                                  // text="Reset"
                                  type="info"
                                  onClicked={() => onReset(item)}
                                />
                              )}
                            </>
                          )}
                          {onDelete !== null && !disableOnDelete && (
                            <>
                              {itemType === "knowledge-base-record" &&
                              item.owner.uuid !== userData.uuid ? (
                                <></>
                              ) : (
                                <Button
                                  icon={<IconClose />}
                                  type="danger"
                                  onClicked={() => onDelete(item)}
                                />
                              )}
                            </>
                          )}
                          {onAccept !== null && !disableOnAccept && (
                            <>
                              <Button
                                icon={<IconPlus />}
                                text="Accept"
                                type="success"
                                onClicked={() => onAccept(item)}
                              />
                            </>
                          )}
                          {onReject !== null && !disableOnReject && (
                            <>
                              <Button
                                icon={<IconClose />}
                                text="Reject"
                                type="danger"
                                onClicked={() => onReject(item)}
                              />
                            </>
                          )}
                        </div>
                      </td>
                    )}

                    {/* Users */}
                    {itemType == "user" && (
                      <>
                        {item.first_name ? (
                          <td>{item.first_name}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.last_name ? (
                          <td>{item.last_name}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.email ? (
                          <td>
                            <a href={`mailto:${item.email}`}>{item.email}</a>
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.phone ? (
                          <td>
                            <a href={`tel:${item.phone}`}>{item.phone}</a>
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.role && <td>{item.role.name}</td>}
                        {item.applications > 0 &&
                        item.applications.length > 0 ? (
                          <td>
                            {item.applications.map((application) => {
                              return (
                                <div key={application.uuid}>
                                  {application.name}
                                </div>
                              );
                            })}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.created_at ? (
                          <td>{item.created_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {/* Profile info */}
                    {itemType === "profile-info" && (
                      <>
                        {item.first_name ? (
                          <td>{item.first_name}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.last_name ? (
                          <td>{item.last_name}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.email ? <td>{item.email}</td> : <td>-</td>}
                        {item.phone ? <td>{item.phone}</td> : <td>-</td>}
                      </>
                    )}

                    {/* Customers */}
                    {itemType === "customer" && (
                      <>
                        {item.first_name ? (
                          <td>{item.first_name}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.last_name ? (
                          <td>{item.last_name}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.email ? (
                          <td>
                            <a href={`mailto:${item.email}`}>{item.email}</a>
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.phone ? (
                          <td>
                            <a href={`tel:${item.phone}`}>{item.phone}</a>
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        <td>
                          <div className="flex flex-direction-column flex-gap-xs text-align-left">
                            <div className="flex flex-justify-between">
                              <b>Country:</b> {item.country ?? "-"}
                            </div>
                            <div className="flex flex-justify-between">
                              <b>State:</b> {item.state ?? "-"}
                            </div>
                            <div className="flex flex-justify-between">
                              <b>City:</b> {item.city ?? "-"}
                            </div>
                            <div className="flex flex-justify-between">
                              <b>Post Code:</b>{" "}
                              {item.postcode ? item.postcode : "-"}
                            </div>
                            <div className="flex flex-justify-between">
                              <b>Address:</b>{" "}
                              {item.address ? item.address : "-"}
                            </div>
                          </div>
                        </td>
                        {item.subscriptions ? (
                          <td>
                            <div
                              className="underlined cursor-pointer"
                              style={{ width: "fit-content" }}
                              onClick={() => onShowCustomerSubscriptions(item)}
                            >
                              See subscriptions ({item.subscriptions.length})
                            </div>
                            <Spacer height="10px" />
                            <div
                              className="underlined cursor-pointer"
                              style={{ width: "fit-content" }}
                              onClick={() => onAddNewCustomerSubscription(item)}
                            >
                              Add new subscription
                            </div>
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {/* Ideas */}
                    {itemType === "idea" && (
                      <>
                        {item.content ? <td>{item.content}</td> : <td>-</td>}
                        {item.created_by ? (
                          <td>{item.created_by}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.created_at ? (
                          <td>{item.created_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {/* Menu settings */}
                    {itemType === "menu-settings" && (
                      <>
                        {item.title ? <td>{item.title}</td> : <td>-</td>}
                        {item.logo_url && (
                          <td>
                            <img src={clientOnlineMenuUrl + item.logo_url} />
                          </td>
                        )}
                        {item.main_image_url && (
                          <td>
                            <img
                              src={clientOnlineMenuUrl + item.main_image_url}
                            />
                          </td>
                        )}
                        <td>
                          <div className="flex flex-direction-column flex-gap-s">
                            {item.phone ? (
                              <div>{item.phone}</div>
                            ) : (
                              <div>-</div>
                            )}
                            {item.email ? (
                              <div>{item.email}</div>
                            ) : (
                              <div>-</div>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="flex flex-direction-column flex-gap-s">
                            <div>
                              Facebook:
                              {item.facebook_url ? (
                                <div>{item.facebook_url}</div>
                              ) : (
                                <div>-</div>
                              )}
                            </div>
                            <div>
                              Instagram:
                              {item.instagram_url ? (
                                <div>{item.instagram_url}</div>
                              ) : (
                                <div>-</div>
                              )}
                            </div>
                            <div>
                              TikTok:
                              {item.tiktok_url ? (
                                <div>{item.tiktok_url}</div>
                              ) : (
                                <div>-</div>
                              )}
                            </div>
                            <div>
                              Twitter:
                              {item.twitter_url ? (
                                <div>{item.twitter_url}</div>
                              ) : (
                                <div>-</div>
                              )}
                            </div>
                            <div>
                              LinkedIn:
                              {item.linkedin_url ? (
                                <div>{item.linkedin_url}</div>
                              ) : (
                                <div>-</div>
                              )}
                            </div>
                          </div>
                        </td>
                        {item.main_language ? (
                          <td>
                            {item.main_language.name} ({item.main_language.code}
                            )
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {/* Menus */}
                    {itemType === "menu" && (
                      <>
                        {item.slogan ? <td>{item.slogan}</td> : <td>-</td>}
                        {item.description ? (
                          <td>{item.description}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.currency ? (
                          <td>{item.currency.symbol}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {/* {item.categories ? (
                          <td>
                            {item.categories.map((category, index) => {
                              const itemsCount = category.items.length;
                              return (
                                <div>
                                  {category.name} ({itemsCount}{" "}
                                  {itemsCount > 1 ? "items" : "item"})
                                </div>
                              );
                            })}
                          </td>
                        ) : (
                          <td>-</td>
                        )} */}
                      </>
                    )}

                    {/* Menu categories */}
                    {itemType === "menu-category" && (
                      <>
                        {item.name ? <td>{item.name}</td> : <td>-</td>}
                        {item.description ? (
                          <td>{item.description}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.items ? (
                          <td>Items ({item.items.length})</td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {/* Menu items */}
                    {itemType === "menu-item" && (
                      <>
                        {item.image_url ? (
                          <td>
                            <img src={clientOnlineMenuUrl + item.image_url} />
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.name ? <td>{item.name}</td> : <td>-</td>}
                        {item.description ? (
                          <td>{item.description}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.price ? <td>{item.price}</td> : <td>-</td>}
                        {item.sale_price ? (
                          <td>{item.sale_price}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.attributes.length > 0 ? (
                          <td>
                            {item.attributes.map(
                              (attribute, attributeIndex) => {
                                return (
                                  <div key={"attribute_" + attributeIndex}>
                                    <u>{attribute.name}</u>
                                    {attribute.options.length > 0 ? (
                                      <div>
                                        {attribute.options.map(
                                          (option, optionIndex) => {
                                            return (
                                              <div
                                                key={"option_" + optionIndex}
                                              >
                                                <div>{option.name}</div>
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    ) : (
                                      <Button
                                        text="Add options"
                                        onClicked={() => {
                                          console.log("test");
                                        }}
                                      />
                                    )}
                                  </div>
                                );
                              }
                            )}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {/* Menu orders */}
                    {itemType === "menu-order" && (
                      <>
                        {item.table_number ? (
                          <td>{item.table_number}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.items ? (
                          <td>
                            {item.items.map((item, index) => {
                              return (
                                <div key={index}>
                                  <h3>
                                    {item.name} x{item.quantity}
                                  </h3>
                                  {item.attributes.length > 0 &&
                                    item.attributes.map(
                                      (attribute, attributeIndex) => {
                                        return (
                                          <div
                                            key={"attribute_" + attributeIndex}
                                          >
                                            <h3>
                                              {attribute.name}:{" "}
                                              {attribute.options[0].name}
                                            </h3>
                                          </div>
                                        );
                                      }
                                    )}
                                </div>
                              );
                            })}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.created_at ? (
                          <td>{item.created_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {itemType === "knowledge-base-record" && (
                      <>
                        {item.name ? <td>{item.name}</td> : <td>-</td>}
                        {item.type ? (
                          <td>
                            {item.type === "dir" ? (
                              <IconFolder />
                            ) : (
                              <IconFile />
                            )}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.description ? (
                          <td>{item.description}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.owner ? (
                          <td>
                            {item.owner.first_name} {item.owner.last_name}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.created_at ? (
                          <td>{item.created_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.updated_at ? (
                          <td>{item.updated_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}

                    {itemType === "knowledge-base-record-trashed" && (
                      <>
                        {item.name ? <td>{item.name}</td> : <td>-</td>}
                        {item.type ? (
                          <td>
                            {item.type === "dir" ? (
                              <IconFolder />
                            ) : (
                              <IconFile />
                            )}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.description ? (
                          <td>{item.description}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.owner ? (
                          <td>
                            {item.owner.first_name} {item.owner.last_name}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.created_at ? (
                          <td>{item.created_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.updated_at ? (
                          <td>{item.updated_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                        {item.marked_as_deleted_at ? (
                          <td>{item.marked_as_deleted_at}</td>
                        ) : (
                          <td>-</td>
                        )}
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    ) : (
      <Message isInline={true} message="No items found." />
    )
  ) : (
    <IconLoadingWave />
  );
}
